import { axios } from '@/utils/request'

const api = {
    getStartList: '/adminapi/dscore/startList',
    getStartMachineList: '/adminapi/dscore/scoreMachineList',
    getStartMachineRankList: '/adminapi/dscore/scoreMachineRankList',
    getStartMachineDetail: '/adminapi/dscore/scoreMachineDetail',
    startListOptions: '/adminapi/dscore/startListOptions',
    startListForMakeOptions: '/adminapi/dscore/startListForMakeOptions',
    getCommentOptions: '/adminapi/dscore/getCommentOptions',
    startListSave: '/adminapi/dscore/startListSave',
    startListTimeSave: '/adminapi/dscore/startListTimeSave',
    getScoreUserList: '/adminapi/dscore/scoreUserList',
    addScoreUser: '/adminapi/dscore/addScoreUser',
    deleteScoreUser: '/adminapi/dscore/deleteScoreUser',
    setStatus: '/adminapi/dscore/setStatus',
    setSubjectStatus: '/adminapi/dscore/setSubjectStatus',
    startListDelete: '/adminapi/dscore/startListDelete',
    getScoreList: '/adminapi/dscore/scoreList',
    getScoreRankList: '/adminapi/dscore/scoreRankList',
    getStartRunList: '/adminapi/dscore/startRunList',
    setScore: '/adminapi/dscore/setScore',
    setTime: '/adminapi/dscore/setTime',
    setCurrent: '/adminapi/dscore/setCurrent',
    setCaipanStatus: '/api/dscore/caipanStatusChange',
    editScoreStartCurrent: '/adminapi/dscore/editScoreStartCurrent',
    getSubjectScoreList: '/adminapi/dscore/subjectScoreList',
    createRankBook: '/adminapi/dscore/createRankBook',
    createPrize: '/adminapi/dscore/createPrize',
    subjectScoreDetail: '/adminapi/dscore/subjectScoreDetail',
    subjectScoreEdit: '/adminapi/dscore/subjectScoreEdit',
    getCreateRankUrls: '/adminapi/dscore/getCreateRankUrls',
    getCertOssUrls: '/adminapi/sai/getCertOssUrls',
    getMemberCertOssUrls: '/adminapi/sai/getMemberCertOssUrls',
    getAllMusicUrls: '/adminapi/dscore/getAllMusicUrls',
    zhixuceDownload: '/adminapi/dscore/zhixuceDownload',
    zhixuceCreate: '/adminapi/dscore/zhixuceCreate',
    setShow: '/adminapi/dscore/setShow', 


    jianqiuStartList: '/adminapi/dscore/jianqiuStartList',
}

export default api

export function startListOptions(parameter) {
    return axios({
        url: api.startListOptions,
        method: 'get',
        params: parameter
    })
}
export function startListForMakeOptions(parameter) {
    return axios({
        url: api.startListForMakeOptions,
        method: 'get',
        params: parameter
    })
}
export function zhixuceDownload(parameter) {
    return axios({
        url: api.zhixuceDownload,
        method: 'get',
        params: parameter
    })
}
export function zhixuceCreate(parameter) {
    return axios({
        url: api.zhixuceCreate,
        method: 'get',
        params: parameter
    })
}
export function scoreCommentOptions(parameter) {
    return axios({
        url: api.getCommentOptions,
        method: 'get',
        params: parameter
    })
}
export function getStartList(parameter) {
    return axios({
        url: api.getStartList,
        method: 'get',
        params: parameter
    })
}
export function getStartMachineList(parameter) {
    return axios({
        url: api.getStartMachineList,
        method: 'get',
        params: parameter
    })
}

export function getStartMachineRankList(parameter) {
    return axios({
        url: api.getStartMachineRankList,
        method: 'get',
        params: parameter
    })
}

export function getStartMachineDetail(parameter) {
    return axios({
        url: api.getStartMachineDetail,
        method: 'get',
        params: parameter
    })
}

export function startListSave(parameter) {
    return axios({
        url: api.startListSave,
        method: 'post',
        data: parameter
    })
}

export function startListTimeSave(parameter) {
    return axios({
        url: api.startListTimeSave,
        method: 'post',
        data: parameter
    })
}

export function deleteScoreUser(parameter) {
    return axios({
        url: api.deleteScoreUser,
        method: 'post',
        data: parameter
    })
}
export function addScoreUser(parameter) {
    return axios({
        url: api.addScoreUser,
        method: 'post',
        data: parameter
    })
}

export function setStatus(parameter) {
    return axios({
        url: api.setStatus,
        method: 'post',
        data: parameter
    })
}

export function setCaipanStatus(parameter) {
    return axios({
        url: api.setCaipanStatus,
        method: 'post',
        data: parameter
    })
}

export function editScoreStartCurrent(parameter) {
    return axios({
        url: api.editScoreStartCurrent,
        method: 'post',
        data: parameter
    })
}

export function setSubjectStatus(parameter) {
    return axios({
        url: api.setSubjectStatus,
        method: 'post',
        data: parameter
    })
}

export function getScoreUserList(parameter) {
    return axios({
        url: api.getScoreUserList,
        method: 'get',
        params: parameter
    })
}

export function startListDelete(parameter) {
    return axios({
        url: api.startListDelete,
        method: 'get',
        params: parameter
    })
}
export function getScoreList(parameter) {
    return axios({
        url: api.getScoreList,
        method: 'get',
        params: parameter
    })
}
export function getScoreRankList(parameter) {
    return axios({
        url: api.getScoreRankList,
        method: 'get',
        params: parameter
    })
}
export function getStartRunList(parameter) {
    return axios({
        url: api.getStartRunList,
        method: 'get',
        params: parameter
    })
}
export function getSubjectScoreList(parameter) {
    return axios({
        url: api.getSubjectScoreList,
        method: 'get',
        params: parameter
    })
}
export function setScore(parameter) {
    return axios({
        url: api.setScore,
        method: 'post',
        data: parameter
    })
}

export function setTime(parameter) {
    return axios({
        url: api.setTime,
        method: 'post',
        data: parameter
    })
}
export function setCurrent(parameter) {
    return axios({
        url: api.setCurrent,
        method: 'post',
        data: parameter
    })
}
export function createRankBook(parameter) {
    return axios({
        url: api.createRankBook,
        method: 'post',
        data: parameter
    })
}
export function createPrize(parameter) {
    return axios({
        url: api.createPrize,
        method: 'post',
        data: parameter
    })
}
export function subjectScoreDetail(parameter) {
    return axios({
        url: api.subjectScoreDetail,
        method: 'get',
        params: parameter
    })
}
export function subjectScoreEdit(parameter) {
    return axios({
        url: api.subjectScoreEdit,
        method: 'post',
        data: parameter
    })
}
export function getCreateRankUrls(parameter) {
    return axios({
        url: api.getCreateRankUrls,
        method: 'post',
        data: parameter
    })
}
export function getCertOssUrls(parameter) {
    return axios({
        url: api.getCertOssUrls,
        method: 'post',
        data: parameter
    })
}
export function getMemberCertOssUrls(parameter) {
    return axios({
        url: api.getMemberCertOssUrls,
        method: 'post',
        data: parameter
    })
}
export function getAllMusicUrls(parameter) {
    return axios({
        url: api.getAllMusicUrls,
        method: 'post',
        data: parameter
    })
}


export function setShow(parameter) {
    return axios({
        url: api.setShow,
        method: 'post',
        data: parameter
    })
}

export function jianqiuStartList(parameter) {
    return axios({
        url: api.jianqiuStartList,
        method: 'post',
        data: parameter
    })
}
